import { gql } from "@apollo/client";

export const CONFIRM_BENEFICIARY_GIFTING_CODE = gql`
  mutation confirmBeneficiaryGiftingCode($beneficiaryId: String!) {
    confirmBeneficiaryGiftingCode(beneficiaryId: $beneficiaryId) {
      giftingUrl
      giftingCode
      isGiftingCodeConfirmed
    }
  }
`;

export const UPDATE_BENEFICIARY_GIFTING_CODE = gql`
  mutation updateBeneficiaryGiftingCode($beneficiaryId: String!, $newGiftingCode: String!) {
    updateBeneficiaryGiftingCode(
      input: { beneficiaryId: $beneficiaryId, newGiftingCode: $newGiftingCode }
    ) {
      giftingUrl
      giftingCode
      isGiftingCodeConfirmed
    }
  }
`;
